export default __webpack_public_path__ + "static/media/approved-icon.a3c54829.svg";